import React, { Component, createRef } from 'react';
import {
    FormControl,
    FormGroup,
    HelpBlock
} from 'react-bootstrap';
import { number, string } from 'prop-types';
import Validator from 'validatorjs';
import {cookiesAccessCheck, sendLoginEmail} from './ApiUtil';
import Utils from './Utils';
import {getIsWidget} from '@bizzabo/website-sections/dist/Utils';
import ThirdPartyCookieModal from './ThirdPartyCookieModal';
import { sendCustomClick } from '../../utils/SnowplowUtils';
import {
    buttonTypes,
    nextButtonSubcategory
} from '../../constants/SnowplowConst';

const validate = data => {
    const rules = {
        email: 'required|email'
    };
    const messages = {
        'email.email': 'Please enter a valid email address',
        'required.email': 'Email address is required'
    };
    const validator = new Validator(data, rules, messages);
    validator.passes();
    return validator.errors.all();
};

/**
 * @deprecated use EmailLoginContainer instead
 */
export default class EmailLoginContainer_Deprecated extends Component {
    static propTypes = {
        eventId: number.isRequired,
        eventGroupId: number.isRequired,
        redirectUrl: string.isRequired,
        headingText: string,
        subHeadingText: string
    };

    static defaultProps = {
        headingText: 'Join Our Event Community',
        subHeadingText: 'Enter your email to join the community'
    };

    state = {
        email: '',
        isLoading: false,
        isSuccess: false,
        touched: false,
        focused: false,
        errors: {},
        serverError: null,
        showThirdPartyCookieModal: false
    };
    toggleShowThirdPartyCookieModal = (show) => {
        this.setState({ showThirdPartyCookieModal: show });
    }

    componentDidMount() {
        Utils.backgroundColorHandler('remove');
    }

    handleEmailChange = ({ target: { value } }) => {
        this.setState({ email: value, errors: validate({ email: value }) });
        this.setServerError(null);
    };

    handleEmailBlur = () => {
        this.setState({ touched: true, focused: false });
    };

    handleEmailFocus = () => {
        this.setState({ focused: true });
    };

    handleSubmit = async e => {
        sendCustomClick(buttonTypes.nextSendEmailButton, nextButtonSubcategory.nextOnOldFlow, this.nextButtonRef);
        e.preventDefault();
        const {
            state: { email, isLoading },
            props: { eventId, eventGroupId, redirectUrl }
        } = this;
        if (isLoading) {
            return;
        }
        try {
            const response = await cookiesAccessCheck();
            const {cookiesAccessible} = response || {};
            if (!cookiesAccessible) {
                this.toggleShowThirdPartyCookieModal(true);
                return ;
            }
        } catch (e) {
            //
        }
        this.lock();
        const isWidget = getIsWidget();
        try {
            await sendLoginEmail({
                eventId,
                eventGroupId,
                email,
                redirectUrl: isWidget ? `${redirectUrl}?widget=true` : redirectUrl
            });
            this.showSuccessMessage();
        } catch (e) {
            e.error && this.setServerError(e.error);
        } finally {
            this.unlock();
        }
    };

    lock = () => this.setState({ isLoading: true });
    unlock = () => this.setState({ isLoading: false });
    showSuccessMessage = () => this.setState({ isSuccess: true });

    shouldShowErrors = () => (
        (this.isInvalid() && this.state.touched) || !!this.state.serverError
    );
    isInvalid = () => {
        const {
            state: {
                errors: { email }
            }
        } = this;
        return !!email;
    };

    setServerError = error => {
        this.setState({ serverError: error });
    };
    getErrorText = () => {
        const {
            state: {
                errors: { email },
                serverError
            }
        } = this;
        return (email && email[0]) || serverError;
    };

    nextButtonRef = createRef();

    renderForm = () => {
        const {
            state: { email, isLoading, focused, touched },
            props: { headingText, subHeadingText },
            handleEmailChange,
            handleSubmit,
            handleEmailBlur,
            handleEmailFocus,
            shouldShowErrors,
            getErrorText,
            isInvalid
        } = this;
        return (
            <form onSubmit={handleSubmit}>
                <div className="text-center">
                    <h1 className="bz-header color-1">{headingText}</h1>
                    { this.props.welcomeMessage ?
                        <div className="bz-paragraph margin-vertical-medium" dangerouslySetInnerHTML={{__html: this.props.welcomeMessage}}/>
                        : null
                    }
                    <p className="bz-paragraph margin-vertical-medium">
                        {subHeadingText}
                    </p>
                    <FormGroup
                        className={shouldShowErrors() ? 'has-error' : ''}
                    >
                        <FormControl
                            className="bz-input input-email"
                            disabled={isLoading}
                            type="text"
                            name="email"
                            value={email}
                            placeholder="Email"
                            onChange={handleEmailChange}
                            onBlur={handleEmailBlur}
                            onFocus={handleEmailFocus}
                        />
                        {shouldShowErrors() && (
                            <HelpBlock>{getErrorText()}</HelpBlock>
                        )}
                    </FormGroup>
                    <button
                        className="bz-button large color-1-background margin-top-small"
                        disabled={isLoading || isInvalid()}
                        ref={this.nextButtonRef}
                        type="submit"
                    >
                        Next
                    </button>
                </div>
            </form>
        );
    };

    renderSuccessMessage = () => {
        const {
            state: { email }
        } = this;
        return (
            <div className="text-center">
                <h1 className="bz-header color-1 margin-bottom-medium">
                    Almost there...
                </h1>
                <p className="bz-paragraph">
                    We've sent an email to <strong>{email}</strong>
                </p>
                <p className="bz-paragraph">
                    Please check your inbox, click the link provided to complete
                    signup
                </p>
                <div className="image-almost-there margin-top-medium" />
            </div>
        );
    };

    render() {
        const {
            state: { isSuccess, showThirdPartyCookieModal}
        } = this;
        return (
            <div className="font-titillium email-login-container">
                {!isSuccess && this.renderForm()}
                {isSuccess && this.renderSuccessMessage()}
                <ThirdPartyCookieModal show={showThirdPartyCookieModal} onHide={()=>this.toggleShowThirdPartyCookieModal(false)}/>
            </div>
        );
    }
}
